<template>
    <el-header class="head-com">
        <el-row>
            <el-col :xs="24" :sm="12" class="logo-container">
                <div class="logo-container-left">
                    <el-avatar shape="square" class="logo" src="../assets/logo.png" />
                    <span class="title">上赛云社区</span>
                </div>
                <el-dropdown class="menuicon hidden-sm-and-up">
                    <span class="el-dropdown-link">
                        <el-icon>
                            <Menu />
                        </el-icon>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item>首页</el-dropdown-item>
                            <el-dropdown-item>关于我们</el-dropdown-item>
                            <el-dropdown-item>帮助</el-dropdown-item>
                            <el-dropdown-item disabled>登录</el-dropdown-item>
                            <el-dropdown-item disabled>注册</el-dropdown-item>
                            <el-dropdown-item divided>
                                <el-icon class="icon" name="wechat">
                                    <WeChatIcon />
                                </el-icon>
                                <span>微信小程序</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </el-col>
            <el-col :sm="12" class="hidden-xs-only">
                <ul router>
                    <li>
                        <el-link title="首页" href="/" underline="never"><span>首页</span></el-link>
                    </li>
                    <li>
                        <el-link title="关于我们" href="/about" underline="never"><span>关于我们</span></el-link>
                    </li>
                    <li>
                        <el-link title="帮助" href="/help" underline="never"><span>帮助</span></el-link>
                    </li>
                    <li v-if="isLoggedIn">
                        <div class="user-thumb">
                            <el-avatar :src="userThumb" size="small" style="margin-right: 8px;"></el-avatar>
                            <el-link title="注销" underline="never" @click="unregist">
                                <span>注销</span>
                            </el-link>
                        </div>
                    </li>
                    <li v-else>
                        <el-link title="登录" href="/login" underline="never" icon="UserFilled">
                            <span>登录</span>
                        </el-link>
                    </li>
                    <li v-if="isLoggedIn">
                        <el-dropdown style="vertical-align: middle;font-weight:500;">
                        <span class="el-dropdown-link">
                            我的<el-icon class="el-icon--right">
                                <ArrowDown />
                            </el-icon>
                        </span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item  @click="$router.push({ name: 'MySource' })">资源</el-dropdown-item>
                                <el-dropdown-item  @click="$router.push({ name: 'MyOrders' })">订单</el-dropdown-item>
                                <el-dropdown-item  @click="$router.push({ name: 'MyInvoices' })">发票</el-dropdown-item>
                                <el-dropdown-item  @click="$router.push({ name: 'ModifyUserInfo' })">个人信息</el-dropdown-item>
                                <el-dropdown-item  @click="$router.push({ name: 'ResetPwd' })">修改密码</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                        </el-dropdown>
                    </li>                
                    <li>
                        <el-link title="注册新用户" href="/regist" underline="never"><span>注册</span></el-link>
                    </li>
                    <li>
                        <el-popover trigger="hover">
                            <template #reference>
                                <el-link title="微信小程序" underline="never">
                                    <el-icon class="icon" name="wechat">
                                        <WeChatIcon />
                                    </el-icon>
                                </el-link>
                            </template>
                            <el-image :src="wxQrcodeImage"></el-image>
                        </el-popover>
                    </li>
                </ul>
            </el-col>
        </el-row>
    </el-header>
</template>

<script lang="ts" setup>
import { ElAvatar, ElRow, ElCol, ElHeader, ElLink, ElIcon } from 'element-plus';
import 'element-plus/dist/index.css';
import WeChatIcon from './WeChatIcon.vue';
import 'element-plus/theme-chalk/display.css';
import { onMounted, ref, watch } from 'vue';
import wxQrcodeImage from '../assets/wxminiprogram.jpg';
import { jwtDecode } from "jwt-decode"
import {loginStore} from '../stores/scene';
const logStore = loginStore();
const isLoggedIn = ref(false); // 假设用户未登录，实际应用中应从状态管理或API获取
const userThumb = ref("");
onMounted(() => {
    // 这里可以添加实际的登录状态检查逻辑
    if (localStorage.getItem('jwtToken')) {
        isLoggedIn.value = true;
        let jwttoken = localStorage.getItem('jwtToken');
        let docde = jwtDecode(jwttoken);
        userThumb.value = docde?.UserThumb ?? '';
    } else {
        isLoggedIn.value = false;
    }
});
watch(()=>[logStore.isLogin, logStore.avatar],([newVal,newthumb])=>{
    if (newVal) {
        isLoggedIn.value=newVal;
    } else {
        isLoggedIn.value = false;
    }
    if(newthumb){
        userThumb.value = newthumb;
    }else{
        userThumb.value = "";
    }

},{immediate:true});


const unregist = () => {

    localStorage.removeItem('jwtToken');
    // localStorage.removeItem('refreshToken');//临时
    isLoggedIn.value = false;
}
</script>

<style lang="scss" scoped>
.head-com {
    background: #fff;
    padding: 8px 0;
    text-align: center;
    border-bottom: 1px solid #e0e0e0;
    line-height: 44px;
    vertical-align: middle;
    box-sizing: border-box;

    .logo-container {
        display: flex;
        align-items: center;
        padding-left: 20px;
        justify-content: space-between;
        align-items: center;

        .logo-container-left {
            height: 44px;
            display: flex;
            align-items: center;

            .logo {
                width: 44px;
                height: 44px;
            }

            .title {
                margin-left: 10px;
                font-size: 24px;
                color: #333;
                font-weight: bold;
            }
        }

        .menuicon {
            font-size: 20px;
            margin-right: 10px;
        }
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-end;

        li {
            display: inline-block;
            margin: 0px 10px;
            font-size: 16px;
            color: #333;
            .user-thumb {
                height: 100%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .el-dropdown-link {
                display: flex;
                align-items: center;
            }
        }

        li:last-child {
            margin-right: 40px;
            border-left: 1px solid #e0e0e0;
            padding-left: 10px;
        }

    }

}

@media screen and (max-width: 768px) {
    .head-com {
        height: 48px;
        padding: 6px 0;
        line-height: 36px;

        .logo-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 16px;

            .logo-container-left {
                height: 36px;
                display: flex;
                align-items: center;

                .logo {
                    width: 36px;
                    height: 36px;
                }

                .title {
                    margin-left: 6px;
                    font-size: 16px;
                    color: #333;
                    font-weight: bold;
                }
            }

        }
    }
}
</style>